import { createNamedContext } from '@utils';

export const ImportOptionsToggleViewContext = createNamedContext<() => void>(undefined, 'Group.Contacts.ImportStepper.ImportOptions.ToggleView.Context');